<div class="container">
  <img *ngFor="let block of blocks" src="assets/img/treasure_hunt/animation/gold-coins.png" class="block" [ngStyle]="{'width.px': block.size, 'height.px': block.size, 'left.%': block.left}" [@fallAnimation]="block.state" (@fallAnimation.done)="animationDone(block)">
</div>
